import { array, number, object, string } from 'yup';

export const TargetRecoveryRateSchema = object({
  branchIds: array()
    .required('You need to indicate at least 1 branch.')
    .min(1, 'You need to select at least 1 branch.')
    .of(number().required()),
  dateRanges: array()
    .required('You need to indicate a Date Range.')
    .min(1, 'You need to select at least 1 date range.')
    .of(string().required()),
  targetRecoveryRate: number('Invalid Target Rate.')
    .required('You need to indicate a Target Rate.')
    .min(1, 'The Target Recovery Rate needs to be greater than or equal to 1%.')
    .max(100, 'The Target Recovery Rate needs to be lower than or equal to 100%.'),
  clientId: string(),
});
